import { service } from './index';
import OptionCustomFieldSelectAndEditComp from '../../field/OptionCustomFieldSelectAndEditComp.vue';
import _ from 'lodash';
import { useFolder } from '@/presentation/composables/folder/use-folder';
export const name = 'OPTION.render';
// 默认显示模板
function renderDefault(h, renderOpts, params) {
    const { _column } = renderOpts;
    const { row, column } = params;
    const idNameMapping = service.getCustomFieldIdNameMapping(column.property, _column._props);
    const attrs = service.getRenderAttrs(row, column, name);
    return [
        // @ts-ignore
        <div class="xtable-cell-render" attrs={attrs}>
            {(row[column.property] || []).map(id => {
                return <div>{idNameMapping[id]}</div>;
            })}
        </div>,
    ];
}
// 可编辑激活模板
function renderEdit(h, renderOpts, params) {
    const { _column } = renderOpts;
    const { row, column } = params;
    const attrs = service.getRenderAttrs(row, column, name);
    const { folderId } = useFolder();
    const editor = (
    // @ts-ignore
    <div class="xtable-cell-editor" attrs={attrs}>
            {/* @ts-ignore */}
            <OptionCustomFieldSelectAndEditComp options={_column._props.field_option_value} selected={row[column.property] || []} folderId={folderId.value} field={_column._props} 
    // @ts-ignore
    on={{
            'end:edit:value': data => service.updateCellValue(row, column, data),
            'end:edit:option': ({ option_id, option_text }) => {
                const options = _.get(_column, '_props.field_option_value');
                const option = _.find(options, { option_id });
                if (option) {
                    option.option_text = option_text;
                }
                else {
                    options.push({ option_id, option_text });
                }
                service.clearCustomFieldIdNameMapping(column.property);
            },
        }}/>
        </div>);
    this.$nextTick(() => {
        service.updateEditorRect(editor, row, column);
    });
    return [editor];
}
// 可编辑显示模板
const renderCell = renderDefault;
// 导出模板，例如导出插槽中自定义的内容
function exportMethod(params) {
    const { row, column } = params;
    const idNameMapping = service.getCustomFieldIdNameMapping(column.property);
    const result = _.map(row[column.property] || [], id => {
        return idNameMapping[id];
    });
    return result.join(',');
}
export default {
    renderDefault,
    renderEdit,
    renderCell,
    exportMethod,
};
